import { Checkbox } from "../ui/checkbox";

export const PermissionsChecklist = ({ catalog, disabled, idPrefix, selected, onChange }) => (
  <div className="grid gap-2 sm:grid-cols-2" data-testid={`${idPrefix}-permissions-checklist`}>
    {catalog.map((item) => (
      <label className="flex items-center gap-2 rounded-xl border border-zinc-200 bg-white px-3 py-2 text-sm text-zinc-700" key={item.key}>
        <Checkbox
          checked={selected.includes(item.key)}
          data-testid={`${idPrefix}-permission-${item.key}`}
          disabled={disabled}
          onCheckedChange={(checked) => {
            onChange(checked ? [...selected, item.key] : selected.filter((key) => key !== item.key));
          }}
        />
        {item.label}
      </label>
    ))}
  </div>
);
